import React from "react";
import { STRINGS } from "../../../strings";
import { globalize, translate } from "../../../translate";
import { disableScroll, enableScroll } from "../../../utils/scroll";
import { AppCard, AppCardContent } from "../../Generic/AppCard";
import { AppSlider } from "../../Generic/AppSlider";
import { AppSliderHandlerProps } from "../../Generic/AppSliderHandler";
import Flex from "../../Generic/Flex";

interface Props {
  maxDistance: number;
  onChange: (maxDistance: number) => void;
}

const MaxTravelDistanceAvailabilityCard = (props: Props) => {
  const handleChange = React.useCallback(
    (value: number | number[] | null | undefined) => {
      if (typeof value !== "number") {
        throw new Error(
          `Got invalid value of handleChange in MaxTravelDistanceAvailabilityCard (${value})`
        );
      }

      props.onChange.call(null, value);
    },
    [props.onChange]
  );

  const miles = React.useMemo(
    () => globalize().formatUnit(props.maxDistance, "mile", { form: "long" }),
    [props.maxDistance]
  );

  const title = React.useMemo(
    () => (
      <div className="__title">
        <strong>
          {translate(STRINGS.MAX_TRAVEL_DISTANCE)}: {miles}
        </strong>
      </div>
    ),
    [miles]
  );

  const sliderHandler = React.useMemo(
    (): AppSliderHandlerProps => ({
      direction: "start",
      children: miles,
    }),
    [miles]
  );

  const slider = (
    <AppSlider
      // https://github.com/mpowaga/react-slider/issues/137
      onBeforeChange={disableScroll}
      onAfterChange={enableScroll}
      withBars={true}
      max={99}
      min={1}
      value={props.maxDistance}
      step={1}
      snapDragDisabled={true}
      onChange={handleChange}
      startHandler={sliderHandler}
    />
  );

  return (
    <AppCard>
      <AppCardContent>
        <Flex direction="column" yGap={16}>
          {title}
          {slider}
        </Flex>
      </AppCardContent>
    </AppCard>
  );
};

export default React.memo(MaxTravelDistanceAvailabilityCard);
